<template>
  <div class="mb-4">
    <h6 class="fw-semibold mb-1">{{ label }}</h6>
    <p class="small text-muted">{{ help }}</p>

    <div class="d-inline-flex align-items-center" @mouseleave="hover = 0">
      <button
        v-for="i in max"
        :key="i"
        type="button"
        class="btn btn-link p-0 me-1"
        :aria-label="i + ' Sterne'"
        @mouseenter="hover = i"
        @click="$emit('input', i)"
      >
        <span :class="i <= (hover || value || 0) ? 'text-warning' : 'text-muted'" class="star">★</span>
      </button>
      <span v-if="value" class="ms-2 small text-muted">{{ value }} / {{ max }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "VoteRating",
  model: { prop: "value", event: "input" },
  props: {
    value: { type: Number, default: 0 },  // v-model
    max: { type: Number, default: 5 },
    label: { type: String, required: true },
    help: { type: String, default: "" },
  },
  data() {
    return { hover: 0 };
  },
};
</script>

<style scoped>
.star { font-size: 1.6rem; line-height: 1; }
</style>
